/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import Popover from "@material-ui/core/Popover";

import Table from "jazasoft/lib/mui/components/Table";
import { useDeepMemo } from "../../../hooks";
import { getDistinctValues, isEmpty } from "../../../utils/helpers";

const StatePopover = props => {
  const { anchorEl, setAnchorEl, stateList = [], unitList = [] } = props;

  const columns = useDeepMemo(() => {
    let cols = [
      { dataKey: "unit", title: "Unit" },
      { dataKey: "fpo", title: "FPO" },
      { dataKey: "product", title: "Product" },
      { dataKey: "part", title: "Part" },
      { dataKey: "lotValue", title: "Lot" },
      { dataKey: "state", title: "State" }
    ];
    const unitCount = getDistinctValues(stateList.map(e => e.unitId).filter(e => !isEmpty(e)))?.length || 0;
    const productCount = getDistinctValues(stateList.map(e => e.product).filter(e => !isEmpty(e)))?.length || 0;
    const partCount = getDistinctValues(stateList.map(e => e.part).filter(e => !isEmpty(e)))?.length || 0;
    const lotCount = getDistinctValues(stateList.map(e => e.lotValue).filter(e => !isEmpty(e)))?.length || 0;

    if (unitCount <= 1) {
      cols = cols.filter(c => c.dataKey !== "unit");
    }
    if (productCount <= 1) {
      cols = cols.filter(c => c.dataKey !== "product");
    }
    if (partCount <= 1) {
      cols = cols.filter(c => c.dataKey !== "part");
    }
    if (lotCount <= 1) {
      cols = cols.filter(c => c.dataKey !== "lotValue");
    }

    return cols;
  }, [stateList]);

  const rows = stateList.map(e => ({ ...e, unit: unitList?.find(u => u.unitId === e.unitId)?.name }));

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={() => setAnchorEl(null)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}>
      <div style={{ minWidth: 360 }}>
        <Table columns={columns} rows={rows} />
      </div>
    </Popover>
  );
};

export default StatePopover;
